import React from 'react';

const EducationalDisclaimer: React.FC = () => (
  <div className="bg-amber-50 border-l-4 border-amber-500 rounded-r-lg p-5 mb-8">
    <div className="flex items-start space-x-3">
      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-alert-line text-amber-600 text-lg"></i>
      </div>
      <div>
        <p className="text-amber-800 font-bold text-sm mb-1">Educational Information Only — Not Legal Advice</p>
        <p className="text-amber-700 text-xs leading-relaxed">
          The information provided on this page is for <strong>educational purposes only</strong> and is based on publicly available data from the Nevada Department of Motor Vehicles (dmv.nv.gov). DMV requirements, fees, forms, and policies are subject to change at any time without notice. This website makes no guarantee that the information displayed is current, complete, or accurate.
        </p>
        <p className="text-amber-700 text-xs leading-relaxed mt-2">
          <strong>By using this website, you automatically agree</strong> that Speedy DMV Services and its affiliates are not responsible for any outdated, incomplete, or inaccurate information, and shall not be held liable for any decisions made based on the content of this site. Always verify current requirements directly with the Nevada DMV at <a href="https://dmv.nv.gov" target="_blank" rel="noopener noreferrer nofollow" className="underline font-semibold">dmv.nv.gov</a> or by calling your local DMV office.
        </p>
      </div>
    </div>
  </div>
);

export default EducationalDisclaimer;
